export const getAppState = (state) => state.app;
